import { makeStyles } from "@material-ui/core";
import { tesaBlue, tesaWhite } from "../../../../styles/colors";

const useStyles = makeStyles({
  root: {
    color: tesaBlue,
    backgroundColor: tesaWhite,
    position: "fixed",
    height: "100%",
    width: "100%",
    textAlign: "center",
    zIndex: 300,
  },
  content: {
    position: "absolute",
    top: "42%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  headline: {
    textTransform: "uppercase",
    marginBlockEnd: 0,
  },
  message: {
    fontSize: "16px",
    lineHeight: "24px",
  },
});

export default useStyles;
